import { gql, TypedDocumentNode } from '@apollo/client';
import { Gender } from '../../generated/types/globalTypes';

export type EmailSubscribeMutation = {
  emailSubscribe: {
    __typename: 'RestEmailSubscribePayload';
    table: {
      __typename: 'RestEmailSubscribeTable';
      isExistingSubscription: boolean;
    };
  };
};

export type NewsletterEmailSubscribeMutationVariables = {
  input: {
    user: {
      email: string;
      gender: Gender;
    };
    placement: 'footer' | 'emailPumoModule' | 'welcomePopup';
  };
};

export type DesignerEmailSubscribeMutationVariables = {
  input: {
    user: {
      email: string;
      gender: Gender;
    };
    placement: 'trunkshow';
    entity_id: number;
    entity_type: 'Trunkshow';
    trunkshow_preview: true;
  };
};

export type EmailSubscribeMutationVariables =
  | NewsletterEmailSubscribeMutationVariables
  | DesignerEmailSubscribeMutationVariables;

export const EMAIL_SUBSCRIBE_MUTATION: TypedDocumentNode<
  EmailSubscribeMutation,
  EmailSubscribeMutationVariables
> = gql`
  mutation EmailSubscribeMutation($input: EmailSubscribeMutationVariables!) {
    emailSubscribe(input: $input)
      @rest(
        type: "RestEmailSubscribePayload"
        path: "/v3.3/users/set_email_newsletter_preferences"
        method: "POST"
      ) {
      table @type(name: "RestEmailSubscribeTable") {
        isExistingSubscription: is_existing_subscription
      }
    }
  }
`;
